'use client';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { JContainer } from '@/components/ui/layout';

export default function Introduce() {
    const { t } = useTranslation('terra1-introduce');
    return (
        <div className="flex w-full flex-col items-center justify-center">
            <h2
                className={clsx(
                    'j-h2 tablet:pt-[160px] tablet:px-0 w-full px-[28px] pt-[80px] text-left text-white sm:text-center',
                )}
            >
                {t('title')}
            </h2>
            <div
                className={clsx(
                    'j-h5 tablet:mt-[24px] tablet:flex tablet:w-3/5 tablet:px-0 tablet:text-center mt-[16px] hidden w-full flex-col items-center justify-center px-[28px] text-left text-[#C8C8C8]',
                )}
            >
                <div>{t('subtitle.firstLine')}</div>
                <div>{t('subtitle.secondLine')}</div>
            </div>
            <div
                className={clsx(
                    'j-h5 tablet:mt-[24px] tablet:hidden tablet:w-3/5 tablet:px-0 tablet:text-center mt-[16px] flex w-full flex-col items-center justify-center px-[28px] text-left text-[#C8C8C8]',
                )}
            >
                {t('subtitle.firstLine')}
                {t('subtitle.secondLine')}
            </div>
            <JContainer
                size="lg"
                padding="md"
                className="tablet:mt-[60px] mt-[40px]"
            >
                <div className="tablet:flex-row tablet:gap-[80px] tablet:rounded-[16px] tablet:p-[60px] flex w-full flex-col gap-[40px] rounded-[8px] border border-[#575757] bg-[#0D0C13] p-[24px]">
                    <div
                        className={clsx(
                            'j-h5 tablet:min-w-[320px] tablet:max-w-[320px] flex min-w-full max-w-full items-center justify-center text-white',
                        )}
                    >
                        <h2 className="hidden">{t('content.left.part1')}</h2>
                        {t('content.left.part1')}
                        {t('content.left.part2')}
                    </div>
                    <div className="tablet:grow tablet:flex-row tablet:gap-[30px] flex grow-0 flex-col gap-[40px]">
                        <div className="tablet:basis-1/2 flex w-full flex-col ">
                            <svg
                                className="h-[48px] w-[48px]"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M24.0002 7.68994C25.9702 7.68994 31.0802 9.18994 36.0402 23.0999C39.2402 32.0499 41.9302 37.3599 43.7402 40.3699H24.0002H4.26018C6.07018 37.3699 8.76018 32.0499 11.9602 23.0999C16.9202 9.18994 22.0302 7.68994 24.0002 7.68994ZM24.0002 5.68994C21.9102 5.68994 15.7102 6.63994 10.0702 22.4299C4.61018 37.7099 0.680176 42.0999 0.440176 42.3599C0.430176 42.3699 0.430176 42.3699 0.430176 42.3699H24.0002H47.5802C47.5802 42.3699 47.5802 42.3699 47.5702 42.3599C47.3302 42.0999 43.4002 37.7099 37.9302 22.4299C32.2902 6.63994 26.0902 5.68994 24.0002 5.68994Z"
                                    fill="#7829FF"
                                />
                                <path
                                    d="M24.0002 19.77C27.6402 19.77 31.6002 23.44 35.1402 30.1C37.7302 34.94 40.2102 38.22 42.2102 40.37H24.0002H5.79018C7.79018 38.21 10.2702 34.94 12.8602 30.09C16.4002 23.43 20.3602 19.77 24.0002 19.77ZM24.0002 17.77C21.9102 17.77 16.7302 18.56 11.0902 29.16C5.63018 39.39 0.740176 42.2 0.440176 42.36C0.430176 42.37 0.430176 42.37 0.430176 42.37H24.0002H47.5802C47.5802 42.37 47.5802 42.37 47.5702 42.36C47.2602 42.2 42.3802 39.39 36.9102 29.15C31.2702 18.55 26.0902 17.77 24.0002 17.77Z"
                                    fill="white"
                                />
                                <path
                                    d="M34.6202 34.92C28.9802 28.94 26.0902 28.5 24.0002 28.5C21.9102 28.5 19.0202 28.94 13.3802 34.92C7.74018 40.88 0.430176 42.37 0.430176 42.37H24.0002H47.5802C47.5802 42.37 40.2602 40.88 34.6202 34.92Z"
                                    fill="url(#paint0_linear_479_3726)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_479_3726"
                                        x1="0.424876"
                                        y1="35.4342"
                                        x2="47.5755"
                                        y2="35.4342"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#7B4EFF" />
                                        <stop
                                            offset="0.5072"
                                            stopColor="#E49599"
                                        />
                                        <stop offset="1" stopColor="#F5C795" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <h3
                                className={clsx(
                                    'j-h5 tablet:mt-[24px] mt-[12px] w-full text-white',
                                )}
                            >
                                {t('content.right.part1.title')}
                            </h3>
                            <div
                                className={clsx(
                                    'j-t1 tablet:mt-[16px] mt-[8px] w-full text-[#C8C8C8]',
                                )}
                            >
                                {t('content.right.part1.content')}
                            </div>
                        </div>
                        <div className="flex basis-1/2 flex-col">
                            <svg
                                className="h-[48px] w-[48px]"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M16.6201 4.55005V31.7001H43.7701V4.55005H16.6201ZM41.7701 29.7001H18.6201V6.55005H41.7701V29.7001Z"
                                    fill="#7829FF"
                                />
                                <path
                                    d="M27.3797 11.2001V13.2001H33.7097L23.2397 23.6601L24.6597 25.0801L35.0797 14.6601V20.8901H37.0797V11.2001H27.3797Z"
                                    fill="white"
                                />
                                <path
                                    d="M31.38 16.9401H4.22998V44.0901H31.38V16.9401Z"
                                    fill="url(#paint0_linear_479_3730)"
                                />
                                <path
                                    d="M17.2561 29.3596L2.98682 43.6289L4.40102 45.0431L18.6703 30.7738L17.2561 29.3596Z"
                                    fill="white"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_479_3730"
                                        x1="17.8053"
                                        y1="16.8512"
                                        x2="17.8053"
                                        y2="43.1316"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#7B4EFF" />
                                        <stop
                                            offset="0.5072"
                                            stopColor="#E49599"
                                        />
                                        <stop offset="1" stopColor="#F5C795" />
                                    </linearGradient>
                                </defs>
                            </svg>

                            <h3
                                className={clsx(
                                    'j-h5 tablet:mt-[24px] mt-[12px] w-full text-white',
                                )}
                            >
                                {t('content.right.part2.title')}
                            </h3>
                            <div
                                className={clsx(
                                    'j-t1 tablet:mt-[16px] mt-[8px] w-full text-[#C8C8C8]',
                                )}
                            >
                                {t('content.right.part2.content')}
                            </div>
                        </div>
                    </div>
                </div>
            </JContainer>
        </div>
    );
}
